<template>
    <canvas @click.capture.stop="click" ></canvas>
</template>
<script>
import Chart from 'chart.js';
export default {
	data(){
		return {
			chartEl:'',
			chartOption:{
				tooltips: {
					mode: 'point',
					enabled:true,
					callbacks: {
						afterLabel: function(tooltipItem, data) {
							const allData = data.datasets[tooltipItem.datasetIndex].data;
							const tooltipLabel = data.labels[tooltipItem.index];
							const tooltipData = allData[tooltipItem.index];
							let total = 0;
							for (var i in allData) {
								total += parseFloat(allData[i]);
							}
							const tooltipPercentage = Math.round((tooltipData / total) * 100);
							return  ' ( ' + tooltipPercentage + '% )';
						},
					}
				},
				legend: {
					onClick:this.click,
				},
				
			},
			chartData:[],
			clickedIndex:-1,
			clickInfo:[],
			
		}
	},
	props:{'selectOne':{type:Function},'showDataset':{type:Function}},
	methods:{
		renderChart(chartData){
			const _ = this.$utils._;
			chartData = JSON.parse(JSON.stringify(chartData));
			const self = this;
			this.clickedIndex = -1;
			this.chartData = chartData;
			if(chartData && chartData.datasets){
				const datasets = chartData.datasets;
				const data = datasets.map(v=>v.data[0]);
				const pieDataset = {
					data,
					backgroundColor:data.map((v,i)=>this.getColor(i)),
					hoverBackgroundColor:'WhiteSmoke'
				}
				const pieData = {
					labels:datasets.map(v=>v.label),
					datasets:[pieDataset]
				};
				this.chartEl.data =  pieData;
				this.chartEl.update();
			}
			
		},
		getColor(i){
			const corlors = ['LightCoral','LightSalmon','LightPink','LightSkyBlue','lightblue','DarkGray','Salmon','SteelBlue','Wheat','Olive','DarkTurquoise'];
			// const corlors = ['OrangeRed','Orchid','GoldenRod','CadetBlue','LimeGreen','DarkGray'];
			return corlors[i];
		},
		doNothing(){

		},
		click(e,item){
			
			const chart = this.chartEl;
			let index;
			if(item){
				index = item.index;
			}else{
				const el = this.chartEl.getElementAtEvent(e)[0];
				index = el && el._index;
				if(!index && index!==0){
					return;
				}
			}
			const dataset = this.chartData.datasets[index];
			if(e.metaKey || e.ctrlKey){
				return this.showDataset(dataset,this.chartData.labels,this.chartData);
			}
			if(this.clickedIndex===index){
				this.chartEl.data.datasets[0].backgroundColor[index] = this.getColor(index);
				this.selectOne(this.chartData.campareBy,'');
				this.clickedIndex = -1;
			}else{
				if(this.clickedIndex!==-1){
					this.chartEl.data.datasets[0].backgroundColor[this.clickedIndex] = this.getColor(this.clickedIndex);
				}
				this.chartEl.data.datasets[0].backgroundColor[index] = 'black';
				this.selectOne(this.chartData.campareBy,dataset.id);
				this.clickedIndex = index;
			}
			chart.update();
		}

	},
	mounted() {
		const ctx = this.$el.getContext('2d');
		const chartEl = this.chartEl = new Chart(ctx, {
			type: 'pie',
			data: [],
			options: this.chartOption
		});
		this.renderChart({});
	},
	
    
}
</script>
